import React from "react";
import { Layout, PageHeader, Space, Table,Modal,  message, Input } from "antd";
import R2Footer from "../../components/Footer";
import { EditOutlined, DeleteOutlined,ExclamationCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import Spinner from "../../components/Layout/Spinner";
import PosService from "../../services/PosService";
import IssueDetails from "./IssueDetails";
import './kpi.scss';

const { Content } = Layout;
const { confirm } = Modal;


const Issues = () => {
  const [isLoading, setLoading] = useState(false);
  const adminRestaurant = useSelector((state) => state.admin);
  const [issues, setIssuelist] = useState([]);
  const [singleItem, setSingleItem] = useState();
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [showDetails, setShowDetails] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
 
 
  useEffect(() => {
    getIssues(searchText);
  }, [adminRestaurant]);

  const getIssues = async (sKey) => {
    setLoading(true)
    const data = await PosService.issues(sKey)
    setIssuelist(data.order_issues);
    setLoading(false)
  };
  const listallMenuItem = (listItem) => {
    const allMenuItem = listItem?.map((mItem)=>mItem.menu_item_name);
   return allMenuItem.join(', ')
  }
 
  const columns = [
    {
      title: "Table No",
      dataIndex: "name",
      key: "name",
      render: (_, record) => {
        return (
          <div style={{ display: "flex" }} >
            <div  className="name_text">
              {record?.table?.table_number}
            </div>
          </div>
        );
      },
    },
    {
        title: "Item",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div style={{ display: "flex" }} >
              <div  className="name_text">
                {listallMenuItem(record?.menu_items)}
              </div>
            </div>
          );
        },
      },
      {
        title: "Issue",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div style={{ display: "flex" }} >
              <div  className="name_text">
                {record?.order_issue?.issue}
              </div>
            </div>
          );
        },
      },
      {
        title: "Solution",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div style={{ display: "flex" }} >
              <div  className="name_text">
                {record?.order_issue?.solution}
              </div>
            </div>
          );
        },
      },
      
      {
        title: "Manager Code",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div style={{ display: "flex" }} >
              <div  className="name_text">
                {record?.order_issue?.manager_code}
               
              </div>
            </div>
          );
        },
      },
      {
        title: "Notes",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div style={{ display: "flex" }} >
              <div  className="name_text">
                {record?.order_issue?.description}
               
              </div>
            </div>
          );
        },
      },
   
    {
      title: "Actions",
      render: (_, record) => {
        return (
          <div
            style={{
              display: "flex",
            }}
          >
            <>
              
              <EditOutlined style={{ fontSize: '19px', color: 'grey',marginLeft:"5px" }}
               onClick={(e)=>{
                e.stopPropagation();
                getsingleIssues(record,true)
              }}/>
              <DeleteOutlined style={{ fontSize: '19px', color: 'red',marginLeft:"5px" }}
              onClick={(e)=>{
                e.stopPropagation();
                handleDelete(record)
              }}/>
            </>
          </div>
        );
      },
    },
  ];
 


  const handleDelete = (record) => {
    confirm({
      title: 'Are you sure to delete?',
      icon: <ExclamationCircleOutlined />,
      content: ' This action cannot be undone.',
  
      onOk() {
        deleteProvider(record)
      },
  
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  const deleteProvider = async(record)=>{
    const dataList = await PosService.deleteIssues(record?.order_issue?.id)
    message.success("Deleted successfully")
    getIssues()
  }

  const getsingleIssues = async(issue,edit=false) =>{
    setLoading(true)
    setIsEdit(edit?true:false)
    const issuebyid = await PosService.getIssueById(issue?.order_issue?.id)
     setSingleItem(issuebyid);
      setShowDetails(true)
    setLoading(false)

  }

  const updateIssues = async(id,payload)=>{
    setLoading(true)
    
    const issuebyid = await PosService.updateOrderIssues(id,payload)
    setLoading(false)
    setShowDetails(false)
    getIssues(searchText);
    message.success("Updated Successfully")
  }
  const showDetailsView=(value)=>{
    setShowDetails(value)
  }
  const handleTableChange = (page) => {
    setPage(page);
  };
  const onSearch = (e) => {
    setSearchText(e.target.value);
    getIssues(e.target.value);
    setPage(1);
  };

  return (
    <Layout className="u-page-layout">
       {showDetails?
      <IssueDetails order={singleItem} setShowDetails ={showDetailsView} isEdit={isEdit}
      updateIssues={updateIssues}/>:
      <Content className="w-full page-padding">
        <Space direction="vertical" style={{ width: "100%" }}>
          <PageHeader
            title="Issues"
            className="page-header"
            extra={[
                <div>
              <Input
                prefix={<SearchOutlined style={{ color: "#262626" }} />}
                placeholder="Search Issues"
                size="middle"
                className="dashboard_searchinput"
                value={searchText}
                onChange={(e)=> {
                  onSearch(e)
                }}
              />
   
              </div>,
            ]}
          />
          <Table
            columns={columns}
            dataSource={issues}
            className="discount-table waitlist-table overflow-auto"
            onRow={(record, rowIndex) => {
              return {
                onClick: (event) => {
                 
                  getsingleIssues(record)
                 
                }, // click row
              };
            }}
            pagination={{current:page,pageSize:10, onChange: handleTableChange}}
            
          />
        </Space>
      </Content>
}
      <R2Footer />
     
      {isLoading &&
      <Spinner/>
}
    </Layout>
  );
};

export default Issues;
